import { useSelector } from 'react-redux';
import { getActiveAssignments } from '../../helpers/task.helper';

const Assignments = (props) => {

  const { user } = useSelector(state => state.user);

  if(!props.assignments) return;
  const currentUser = user.userName.toUpperCase();
  return <ul className="a-list assignments">
    {
      getActiveAssignments(props.assignments).map((assignment) => {
        const isCurrentUser = currentUser === assignment.todoAppUser.maccount;
        return (<li key={assignment.id}>
          <span className={ isCurrentUser ? "u-text-bold" : "" }>
            { assignment.todoAppUser.name }
          </span>
        </li>)
      })
    }
  </ul>
};

export default Assignments;
